import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const SELECT_ONE_IMAGE_INTERNAL_IN_GALLERY = 'SELECT_ONE_IMAGE_INTERNAL_IN_GALLERY';
export type SELECT_ONE_IMAGE_INTERNAL_IN_GALLERY = typeof SELECT_ONE_IMAGE_INTERNAL_IN_GALLERY;

export interface SelectOneImageInternalInGallery {
    type: SELECT_ONE_IMAGE_INTERNAL_IN_GALLERY;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    imageHash: string;
}

export function selectOneImageInternalInGalleryAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    imageHash: string
): SelectOneImageInternalInGallery {
    return {
        type: SELECT_ONE_IMAGE_INTERNAL_IN_GALLERY,
        bannerId,
        resourceId,
        imageHash
    };
}
